module.exports = __webpack_public_path__ + "img/milestone-last-active.de5c7dc0.png";